import React from 'react';
import Relay from 'react-relay';

import Button from '../../components/Button';

export default class DashboardPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: null
        }
    }

    handleTabChange() {
        let {that, index, text} = this.props ;
        
        that.setState({
            activeTab: index
        });
        
        let path = '/dashboard/'+text.toLowerCase();
        that.props.router.push({
            pathname : path
        });
    }

    _renderTab(tab, index) {
        let color = 'btn-default';
        if (index == this.state.activeTab)
            color = 'btn-danger';
        
        return (
            <Button 
                key={index} 
                that={this} 
                index={index}
                text={tab} 
                color={color} 
                onClick={this.handleTabChange} 
            />
        );
    }

    render() {
        let tabs = ["Users","Sportunities", "Circles", "Sports"];

        return (
            <div className="container">
                <div style={{marginTop:20}}>
                    {tabs.map((tab, index) => this._renderTab(tab, index))}
                </div>
                {this.props.children}
            </div>            
        )

    }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/DashboardPage.js